export default __webpack_public_path__ + "static/media/regulatory--no-motor-vehicles-except-motorcycles--g3.a4448c41.png";